/* 22 Oct 2026 - Observations #21: sticky Add to Cart on mobile.
   Clicks the real #product-add-to-cart, so variant, quantity and GA4 add_to_cart stay as today. */
(function(){
  var main=document.getElementById('product-add-to-cart');
  if(!main||!('IntersectionObserver' in window)) return;
  var scope=main.closest('[itemscope]')||document;
  var h1=document.querySelector('h1[itemprop=name]');
  var bar=document.createElement('div');
  bar.className='kt-sticky-atc'; bar.setAttribute('aria-hidden','true');
  bar.innerHTML='<div class="kt-sticky-atc__info"><span class="kt-sticky-atc__title"></span><span class="kt-sticky-atc__price"></span></div><button type="button" class="kt-sticky-atc__btn"></button>';
  var title=bar.querySelector('.kt-sticky-atc__title'), price=bar.querySelector('.kt-sticky-atc__price'), btn=bar.querySelector('.kt-sticky-atc__btn');
  title.textContent=h1?h1.textContent.trim():'';
  function sync(){
    btn.disabled=!!main.disabled;
    btn.textContent=((main.value||main.textContent||'Add to Cart')+'').trim();
    var p=scope.querySelector('[itemprop=price]');
    if(p&&p.textContent.trim()) price.textContent=p.textContent.trim().replace(/\s*USD$/,'');
  }
  btn.addEventListener('click',function(){ sync(); if(!main.disabled) main.click(); });
  document.body.appendChild(bar); sync();
  new IntersectionObserver(function(e){
    var show=!e[0].isIntersecting;
    bar.classList.toggle('is-visible',show);
    bar.setAttribute('aria-hidden',show?'false':'true');
    document.body.classList.toggle('kt-sticky-atc-on',show);
    if(show) sync();
  },{threshold:0}).observe(main);
  new MutationObserver(sync).observe(main,{attributes:true});
  var pr=scope.querySelector('[itemprop=price]');
  if(pr) new MutationObserver(sync).observe(pr,{childList:true,subtree:true,characterData:true});
})();
